import 'react';
import { LinkInspector } from '../../Link/LinkInspector.js';
import { jsx } from '@emotion/react';

function ImageMapLinkInspector(props) {
  var assertedProps = props;
  return jsx(LinkInspector, assertedProps);
}

export { ImageMapLinkInspector };
//# sourceMappingURL=ImageMapLink.Inspector.js.map
